// @ts-nocheck

import { Route as rootRoute } from '../routes/__root';
import { Route as AdminGalleriesRoute } from '../routes/admin/galleries';
import { Route as DashboardGallerySubscriptionRoute } from '../routes/dashboard/gallery.subscription';
import { Route as GalleryApiTokensRoute } from '../routes/gallery/api-tokens';
import { Route as GalleryApplyRoute } from '../routes/gallery/apply';
import { Route as GalleryArtworksUuidRoute } from '../routes/gallery/artworks.$uuid';
import { Route as GalleryArtworksIndexRoute } from '../routes/gallery/artworks.index';
import { Route as GalleryArtworksNewRoute } from '../routes/gallery/artworks.new';
import { Route as GalleryIndexRoute } from '../routes/gallery/index';
import { Route as GalleryProvenanceRoute } from '../routes/gallery/provenance';
import { Route as GallerySubscriptionRoute } from '../routes/gallery/subscription';

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/dashboard/gallery/subscription': {
      id: '/dashboard/gallery/subscription';
      path: '/dashboard/gallery/subscription';
      fullPath: '/dashboard/gallery/subscription';
      preLoaderRoute: typeof DashboardGallerySubscriptionRoute;
      parentRoute: typeof rootRoute;
    };
    '/gallery/': {
      id: '/gallery/';
      path: '/gallery';
      fullPath: '/gallery';
      preLoaderRoute: typeof GalleryIndexRoute;
      parentRoute: typeof rootRoute;
    };
    '/gallery/api-tokens': {
      id: '/gallery/api-tokens';
      path: '/gallery/api-tokens';
      fullPath: '/gallery/api-tokens';
      preLoaderRoute: typeof GalleryApiTokensRoute;
      parentRoute: typeof rootRoute;
    };
    '/gallery/apply': {
      id: '/gallery/apply';
      path: '/gallery/apply';
      fullPath: '/gallery/apply';
      preLoaderRoute: typeof GalleryApplyRoute;
      parentRoute: typeof rootRoute;
    };
    '/gallery/artworks/': {
      id: '/gallery/artworks/';
      path: '/gallery/artworks';
      fullPath: '/gallery/artworks';
      preLoaderRoute: typeof GalleryArtworksIndexRoute;
      parentRoute: typeof rootRoute;
    };
    '/gallery/artworks/new': {
      id: '/gallery/artworks/new';
      path: '/gallery/artworks/new';
      fullPath: '/gallery/artworks/new';
      preLoaderRoute: typeof GalleryArtworksNewRoute;
      parentRoute: typeof rootRoute;
    };
    '/gallery/artworks/$uuid': {
      id: '/gallery/artworks/$uuid';
      path: '/gallery/artworks/$uuid';
      fullPath: '/gallery/artworks/$uuid';
      preLoaderRoute: typeof GalleryArtworksUuidRoute;
      parentRoute: typeof rootRoute;
    };
    '/gallery/provenance': {
      id: '/gallery/provenance';
      path: '/gallery/provenance';
      fullPath: '/gallery/provenance';
      preLoaderRoute: typeof GalleryProvenanceRoute;
      parentRoute: typeof rootRoute;
    };
    '/gallery/subscription': {
      id: '/gallery/subscription';
      path: '/gallery/subscription';
      fullPath: '/gallery/subscription';
      preLoaderRoute: typeof GallerySubscriptionRoute;
      parentRoute: typeof rootRoute;
    };
    '/admin/galleries': {
      id: '/admin/galleries';
      path: '/admin/galleries';
      fullPath: '/admin/galleries';
      preLoaderRoute: typeof AdminGalleriesRoute;
      parentRoute: typeof rootRoute;
    };
  }
}

const DashboardGallerySubscriptionRouteWithChildren = DashboardGallerySubscriptionRoute.update({
  id: '/dashboard/gallery/subscription',
  path: '/dashboard/gallery/subscription',
  getParentRoute: () => rootRoute,
});

const GalleryApiTokensRouteWithChildren = GalleryApiTokensRoute.update({
  id: '/gallery/api-tokens',
  path: '/gallery/api-tokens',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/gallery/api-tokens.lazy').then((d) => d.Route));

const GallerySubscriptionRouteWithChildren = GallerySubscriptionRoute.update({
  id: '/gallery/subscription',
  path: '/gallery/subscription',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/gallery/subscription.lazy').then((d) => d.Route));

const AdminGalleriesRouteWithChildren = AdminGalleriesRoute.update({
  id: '/admin/galleries',
  path: '/admin/galleries',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/admin/galleries.lazy').then((d) => d.Route));

const GalleryIndexRouteWithChildren = GalleryIndexRoute.update({
  id: '/gallery/',
  path: '/gallery',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/gallery/index.lazy').then((d) => d.Route));

const GalleryApplyRouteWithChildren = GalleryApplyRoute.update({
  id: '/gallery/apply',
  path: '/gallery/apply',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/gallery/apply.lazy').then((d) => d.Route));

const GalleryArtworksIndexRouteWithChildren = GalleryArtworksIndexRoute.update({
  id: '/gallery/artworks/',
  path: '/gallery/artworks',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/gallery/artworks.index.lazy').then((d) => d.Route));

const GalleryArtworksNewRouteWithChildren = GalleryArtworksNewRoute.update({
  id: '/gallery/artworks/new',
  path: '/gallery/artworks/new',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/gallery/artworks.new.lazy').then((d) => d.Route));

const GalleryArtworksUuidRouteWithChildren = GalleryArtworksUuidRoute.update({
  id: '/gallery/artworks/$uuid',
  path: '/gallery/artworks/$uuid',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/gallery/artworks.$uuid.lazy').then((d) => d.Route));

const GalleryProvenanceRouteWithChildren = GalleryProvenanceRoute.update({
  id: '/gallery/provenance',
  path: '/gallery/provenance',
  getParentRoute: () => rootRoute,
}).lazy(() => import('../routes/gallery/provenance.lazy').then((d) => d.Route));

export const galleryChildren = {
  DashboardGallerySubscriptionRoute: DashboardGallerySubscriptionRouteWithChildren,
  AdminGalleriesRoute: AdminGalleriesRouteWithChildren,
  GalleryIndexRoute: GalleryIndexRouteWithChildren,
  GalleryApiTokensRoute: GalleryApiTokensRouteWithChildren,
  GalleryApplyRoute: GalleryApplyRouteWithChildren,
  GalleryArtworksIndexRoute: GalleryArtworksIndexRouteWithChildren,
  GalleryArtworksNewRoute: GalleryArtworksNewRouteWithChildren,
  GalleryArtworksUuidRoute: GalleryArtworksUuidRouteWithChildren,
  GalleryProvenanceRoute: GalleryProvenanceRouteWithChildren,
  GallerySubscriptionRoute: GallerySubscriptionRouteWithChildren,
};
